export const getPeriodType = (periodType, translate) => {

    switch(periodType) { 
        case "DAY": { 
           return translate("DetailEventReleaseWeekly") 
        } 
        case "MONTH": { 
           return translate("DetailEventReleaseMonthly")
        }
  
        case "QUARTER": { 
            return translate("DetailEventReleaseQuarterly")
        } 
        default: { 
            return translate("DetailEventReleaseIrregular")
        }
    }
  }